import { type Theme } from '@logto/schemas';

import styles from './index.module.scss';

type Props = {
  readonly className?: string;
  readonly theme: Theme;
};

// The historical component name remains compatible with customer CSS and account-center imports.
const LogtoSignature = ({ className, theme }: Props) => (
  <div className={className} data-theme={theme}>
    <span aria-label="JX Account" className={styles.signature}>
      JX Account
    </span>
  </div>
);

export default LogtoSignature;
